import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { MapPin, Ruler, Wallet, Sprout, ArrowUpRight } from 'lucide-react';
import { useConnect } from '../context/ConnectContext';

export default function ProjectDetail({ project, onClose }) {
  const { openConnect } = useConnect();
  const open = Boolean(project);
  if (!project) return null;

  const metricList = project.metrics
    ? [
        { k: 'Target Net IRR', v: project.metrics.irr },
        { k: 'Net Equity Multiple', v: project.metrics.multiple },
        { k: 'Net Cash Yield', v: project.metrics.yield },
        { k: 'Target Hold', v: project.metrics.hold },
      ]
    : [];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl overflow-hidden border-white/10 bg-farmway-green-dark p-0 text-farmway-cream">
        <div className="relative h-56">
          <img src={project.image} alt={project.name} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-farmway-green-dark via-farmway-green-dark/40 to-transparent" />
          <div className="absolute bottom-4 left-6 right-6">
            <span
              className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 font-display text-[11px] font-bold uppercase tracking-wider ${
                project.status === 'Open' ? 'bg-farmway-gold text-farmway-green' : 'bg-white/15 text-farmway-cream'
              }`}
            >
              {project.status}
            </span>
            <h3 className="mt-2 font-display text-3xl font-black uppercase tracking-tight">{project.name}</h3>
            <p className="mt-1 flex items-center gap-1.5 text-sm text-farmway-cream/80">
              <MapPin className="h-4 w-4 text-farmway-gold" />
              {project.location}, {project.country}
            </p>
          </div>
        </div>

        <div className="p-6">
          <p className="text-sm leading-relaxed text-farmway-cream/75">{project.summary}</p>

          {metricList.length > 0 && (
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {metricList.map((m) => (
                <div key={m.k} className="rounded-xl bg-white/5 p-3 text-center">
                  <p className="font-display text-xl font-bold text-farmway-gold">{m.v}</p>
                  <p className="mt-1 text-[10px] uppercase tracking-wider text-farmway-cream/50">{m.k}</p>
                </div>
              ))}
            </div>
          )}

          <div className="mt-5 grid grid-cols-3 gap-3 border-t border-white/10 pt-5">
            <div className="flex items-center gap-2">
              <Sprout className="h-4 w-4 text-farmway-leaf" />
              <div>
                <p className="text-[10px] uppercase tracking-wider text-farmway-cream/50">Crop</p>
                <p className="text-sm font-medium">{project.crop}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Ruler className="h-4 w-4 text-farmway-leaf" />
              <div>
                <p className="text-[10px] uppercase tracking-wider text-farmway-cream/50">Size</p>
                <p className="text-sm font-medium">{project.size}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Wallet className="h-4 w-4 text-farmway-leaf" />
              <div>
                <p className="text-[10px] uppercase tracking-wider text-farmway-cream/50">Project size</p>
                <p className="text-sm font-medium">{project.projectSize}</p>
              </div>
            </div>
          </div>

          <button
            onClick={() => {
              onClose();
              setTimeout(openConnect, 150);
            }}
            className="btn-gold mt-6 w-full"
          >
            Enquire about this project <ArrowUpRight className="h-4 w-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
